import {VIEW_STUDENT_ROOM_MANUAL} from './types'

const initialState = {
    studentRoom: []
};

const studentRoomReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case VIEW_STUDENT_ROOM_MANUAL:
            
            return {
                ...state,
                studentRoom: payload
            };
        default:
            return state;
    }
};

export default studentRoomReducer;